import React from 'react';
import { Link, useLocation, Navigate } from 'react-router-dom';
import RegisterForm from '../components/auth/RegisterForm';
import { useAuthStore } from '../store/authStore';

const Register: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuthStore();
  const from = (location.state as { from?: string })?.from || '/';

  // Redirect if already authenticated
  if (isAuthenticated) {
    return <Navigate to={from} replace />;
  }

  return (
    <div className="min-h-[80vh] flex">
      {/* Left side - Image/Info (hidden on mobile) */}
      <div className="hidden lg:flex flex-1 bg-gradient-to-br from-amber-600 to-amber-800 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{ 
            backgroundImage: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.4"%3E%3Cpath d="M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")'
          }} />
        </div>
        
        <div className="relative z-10 flex flex-col justify-center p-12 text-white">
          <h2 className="text-4xl font-bold mb-6">
            Comece a vender<br />
            hoje mesmo!
          </h2>
          
          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 text-2xl">
                🆓
              </div>
              <div>
                <h3 className="font-semibold text-lg">Cadastro gratuito</h3>
                <p className="text-amber-100">Crie sua conta sem nenhum custo</p>
              </div>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 text-2xl">
                📸
              </div>
              <div>
                <h3 className="font-semibold text-lg">Anuncie facilmente</h3>
                <p className="text-amber-100">Publique em minutos com fotos e descrição</p>
              </div>
            </div>
            
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 text-2xl">
                💰
              </div>
              <div>
                <h3 className="font-semibold text-lg">Venda mais</h3>
                <p className="text-amber-100">Alcance milhares de compradores interessados</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 text-2xl">
                ⭐
              </div>
              <div>
                <h3 className="font-semibold text-lg">Destaque-se</h3>
                <p className="text-amber-100">Planos premium para aumentar sua visibilidade</p>
              </div>
            </div>
          </div>

          <div className="mt-12 p-6 bg-white/10 rounded-xl backdrop-blur-sm">
            <p className="text-amber-100 text-sm mb-2">Junte-se a mais de</p>
            <p className="text-4xl font-bold">5.000+ vendedores</p>
            <p className="text-amber-100 text-sm mt-2">que já estão vendendo no BOILX</p>
          </div>
        </div>
      </div>

      {/* Right side - Form */}
      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <Link to="/" className="inline-flex items-center gap-2 mb-6">
              <span className="text-4xl">🐴</span>
              <span className="text-2xl font-bold text-green-700">
                BOIL<span className="text-amber-700">X</span>
              </span>
            </Link>
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              Crie sua conta
            </h1>
            <p className="text-gray-600">
              É rápido, fácil e grátis
            </p>
          </div>

          <RegisterForm redirectTo={from} />
        </div>
      </div>
    </div>
  );
};

export default Register;
